export const getUrlParams = (name: string) => {
  const params = new URLSearchParams(document.location.search)
  return params.get(name)
}
